// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.single-banner-section .single-banner-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.single-banner-section .single-banner-wrap .single-banner-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  position: relative;
}
.single-banner-section .single-banner-wrap .single-banner-box .text-box {
  width: 100%;
  max-width: 53.375rem;
}
.single-banner-section .single-banner-wrap .single-banner-box .text-box .title-text {
  color: var(--primaryMain-1000);
  font-family: "TiltWarp", sans-serif;
  font-size: 4rem;
  font-weight: 400;
  line-height: 1.25;
  margin-bottom: 1.25rem;
}
.single-banner-section .single-banner-wrap .single-banner-box .text-box .title-text span {
  color: var(--black-1000);
  display: block;
}
.single-banner-section .single-banner-wrap .single-banner-box .text-box .para-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
.single-banner-section .single-banner-wrap .single-banner-box .text-box .btn-box {
  margin-top: 3rem;
}
.single-banner-section .single-banner-wrap .single-banner-box .text-box .contact-img-box {
  display: inline-block;
  margin-top: 3rem;
  transition: 200ms all ease-in-out;
}
.single-banner-section .single-banner-wrap .single-banner-box .text-box .contact-img-box img {
  width: 100%;
  max-width: 15.625rem;
  height: auto;
  display: block;
}
.single-banner-section .single-banner-wrap .single-banner-box .text-box .contact-img-box:hover {
  transform: scale(0.95);
}
.single-banner-section .single-banner-wrap .single-banner-box .img-box {
  width: 100%;
  max-width: 43.125rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.single-banner-section .single-banner-wrap .single-banner-box .img-box img {
  width: 100%;
  max-width: 100%;
  height: auto;
}
@media screen and (max-width: 991.98px) {
  .single-banner-section .single-banner-wrap .single-banner-box .text-box {
    max-width: 29rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .text-box .title-text {
    font-size: 2.5rem;
    margin-bottom: 1rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .text-box .para-text {
    font-size: 1rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .text-box .btn-box {
    margin-top: 1.5rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .text-box .contact-img-box {
    margin-top: 1.5rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .text-box .contact-img-box img {
    max-width: 10rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .img-box {
    max-width: 20rem;
  }
}
@media screen and (max-width: 767.98px) {
  .single-banner-section .single-banner-wrap .single-banner-box .text-box {
    max-width: 35rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .text-box .title-text {
    font-size: 2rem;
    margin-bottom: 1rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .text-box .para-text {
    font-size: 0.875rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .text-box .btn-box {
    margin-top: 1rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .text-box .contact-img-box {
    margin-top: 1rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .text-box .contact-img-box img {
    max-width: 8rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .img-box {
    max-width: 12rem;
  }
}
@media screen and (max-width: 639.98px) {
  .single-banner-section .single-banner-wrap .single-banner-box .text-box {
    max-width: unset;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .text-box .title-text {
    font-size: 1.75rem;
    margin-bottom: 0.75rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .text-box .para-text {
    font-size: 0.875rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .text-box .btn-box {
    margin-top: 1rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .text-box .contact-img-box {
    margin-top: 1rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .text-box .contact-img-box img {
    max-width: 6rem;
  }
  .single-banner-section .single-banner-wrap .single-banner-box .img-box {
    max-width: 6rem;
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SingleBannerSection/SingleBannerStyle.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AAAJ;AAEI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAAN;AAEM;EACE,WAAA;EACA,oBAAA;AAAR;AAEQ;EACE,8BAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAAV;AAEU;EACE,wBAAA;EACA,cAAA;AAAZ;AAIQ;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAFV;AAKQ;EACE,gBAAA;AAHV;AAMQ;EACE,qBAAA;EACA,gBAAA;EACA,iCAAA;AAJV;AAMU;EACE,WAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;AAJZ;AAOU;EACE,sBAAA;AALZ;AAUM;EACE,WAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AARR;AAUQ;EACE,WAAA;EACA,eAAA;EACA,YAAA;AARV;AAcE;EAGM;IACE,gBAAA;EAdR;EAgBQ;IACE,iBAAA;IACA,mBAAA;EAdV;EAiBQ;IACE,eAAA;EAfV;EAkBQ;IACE,kBAAA;EAhBV;EAmBQ;IACE,kBAAA;EAjBV;EAmBU;IACE,gBAAA;EAjBZ;EAsBM;IACE,gBAAA;EApBR;AACF;AAyBE;EAGM;IACE,gBAAA;EAzBR;EA2BQ;IACE,eAAA;IACA,mBAAA;EAzBV;EA4BQ;IACE,mBAAA;EA1BV;EA6BQ;IACE,gBAAA;EA3BV;EA8BQ;IACE,gBAAA;EA5BV;EA8BU;IACE,eAAA;EA5BZ;EAiCM;IACE,gBAAA;EA/BR;AACF;AAoCE;EAGM;IACE,gBAAA;EApCR;EAsCQ;IACE,kBAAA;IACA,sBAAA;EApCV;EAuCQ;IACE,mBAAA;EArCV;EAwCQ;IACE,gBAAA;EAtCV;EAyCQ;IACE,gBAAA;EAvCV;EAyCU;IACE,eAAA;EAvCZ;EA4CM;IACE,eAAA;IACA,aAAA;EA1CR;AACF","sourcesContent":[".single-banner-section {\n  .single-banner-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .single-banner-box {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 1rem;\n      position: relative;\n\n      .text-box {\n        width: 100%;\n        max-width: 53.375rem;\n\n        .title-text {\n          color: var(--primaryMain-1000);\n          font-family: \"TiltWarp\", sans-serif;\n          font-size: 4rem;\n          font-weight: 400;\n          line-height: 1.25;\n          margin-bottom: 1.25rem;\n\n          span {\n            color: var(--black-1000);\n            display: block;\n          }\n        }\n\n        .para-text {\n          color: var(--black-1000);\n          font-size: 1.5rem;\n          font-weight: 400;\n          line-height: 1.4;\n        }\n\n        .btn-box {\n          margin-top: 3rem;\n        }\n\n        .contact-img-box {\n          display: inline-block;\n          margin-top: 3rem;\n          transition: 200ms all ease-in-out;\n\n          img {\n            width: 100%;\n            max-width: 15.625rem;\n            height: auto;\n            display: block;\n          }\n\n          &:hover {\n            transform: scale(0.95);\n          }\n        }\n      }\n\n      .img-box {\n        width: 100%;\n        max-width: 43.125rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        img {\n          width: 100%;\n          max-width: 100%;\n          height: auto;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    .single-banner-wrap {\n      .single-banner-box {  \n        .text-box {  \n          max-width: 29rem;\n\n          .title-text {\n            font-size: 2.5rem;\n            margin-bottom: 1rem;\n          }\n  \n          .para-text {\n            font-size: 1rem;\n          }\n\n          .btn-box {\n            margin-top: 1.5rem;\n          }\n  \n          .contact-img-box {\n            margin-top: 1.5rem;\n  \n            img {\n              max-width: 10rem;\n            }\n          }\n        }\n  \n        .img-box {\n          max-width: 20rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    .single-banner-wrap {\n      .single-banner-box {  \n        .text-box {  \n          max-width: 35rem;\n\n          .title-text {\n            font-size: 2rem;\n            margin-bottom: 1rem;\n          }\n  \n          .para-text {\n            font-size: 0.875rem;\n          }\n\n          .btn-box {\n            margin-top: 1rem;\n          }\n  \n          .contact-img-box {\n            margin-top: 1rem;\n  \n            img {\n              max-width: 8rem;\n            }\n          }\n        }\n  \n        .img-box {\n          max-width: 12rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 639.98px) {\n    .single-banner-wrap {\n      .single-banner-box {  \n        .text-box {  \n          max-width: unset;\n\n          .title-text {\n            font-size: 1.75rem;\n            margin-bottom: 0.75rem;\n          }\n  \n          .para-text {\n            font-size: 0.875rem;\n          }\n\n          .btn-box {\n            margin-top: 1rem;\n          }\n  \n          .contact-img-box {\n            margin-top: 1rem;\n  \n            img {\n              max-width: 6rem;\n            }\n          }\n        }\n  \n        .img-box {\n          max-width: 6rem;\n          display: none;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
